
import { Component, Mixins, Watch } from "vue-property-decorator";
import { IItem } from "../../../../../../../domain/document/items";
import { NumberValueAccessor } from "../accessors";
import { default as ObjectReferableContentMixin } from "./ObjectReferableContentMixin.vue";

@Component
export default class NumberInputtableContentMixin extends Mixins(ObjectReferableContentMixin) {
  data() {
    return {
      accessor: null as NumberValueAccessor,
      error: "",
    };
  }
  accessor: NumberValueAccessor;
  error: string;

  get text(): string {
    return this.accessor
      ? this.accessor.get()
      : "";
  }

  set text(value: string) {
    if (this.accessor) {
      this.updateItem(this.accessor.set(value));
    }
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  mounted() {
    this.initialize(this.item);
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }

  initialize(newValue: IItem) {
    try {
      this.accessor = new NumberValueAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }
}
